<template>
  <div id="app">
    <transition name="page">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  text-align: center;
  color: #121212;
  /* background: #FFB91D; */
  /* background: #FCF6C3; */
  background: url(/static/background.png);
  /* background-size: 30%; */
}
#app .grid {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
/* .grid > header {
  margin-top: 2em;
  margin-bottom: 2em;
} */
.grid > footer {
  margin-top: auto;
}
/* .container.is-fluid {
  margin-left: 32px;
  margin-right: 32px;
} */
.title {
  color: #121212;
}
.box, 
.card {
  /* border: 5px solid #121212; */
  /* border-radius: 10px; */
  border: 0;
  background: none transparent;
  position: relative;
  z-index: 1;
  box-shadow: none;
}
.box:before, 
.card:before {
  content: '';
  position: absolute;
  top: -5px;
  bottom: -5px;
  left: -4px;
  width: calc(100% + 10px);
  transform: skew(-1.6deg, -0.4deg);
  z-index: -1;
  border-radius: 10px;
  border: 5px solid #003A85;
  border-radius: 10px;
  background: rgb(255, 255, 252);
  box-shadow: 0 2px 3px #0a0a0a1a, 0 0 0 1px #0a0a0a1a;
}
/* .box:nth-child(odd):before, 
.card:nth-child(odd):before {
  transform: skew(0.5deg, 0.5deg);
} */
.page-enter-active {
  transition: opacity 0.25s ease-out;
}
.page-leave-active {
  transition: opacity 0.25s ease-in;
}
.page-enter,
.page-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue